module.exports = __webpack_public_path__ + "static/media/uparrow.8205df1b.png";